
<ng-container *ngIf="jackpot?.length > 0 && SGisActive && onGetCurrencyCode() =='SGD' ; else elseTemplate">
  <div class="slider-inner" >
    <div class="swiper-container swiper-parent">
      <owl-carousel-o [options]="customOptionsJacpot">
        <ng-template carouselSlide *ngFor="let gameCode of gameCodeByJacpotPostion; let g = index">
          <ng-container *ngFor="let item of jackpot; let i = index">
            <div class="custom-contaier m-0 p-0" *ngIf="item.amount[onGetCurrencyCode()] && gameCode == item.code  && gameList[gameCodeByJacpot[item.code]] && item.GameProviderCode == 'SG' ">
              <img class="d-block w-100"  [src]="'assets/jackpot/' + item.code + '/'+ item.code +'.gif'" [alt]="item.name">
              <div class="custom-contaier-jackpot">
                <img class="d-block jackpot-bg  w-100"  [src]="'assets/jackpot/' + item.code + '/'+ item.code +'_title.gif'" [alt]="item.name">
                <div class="d-block jackpot-button m-0 p-0"  (click)="onLaunchGame(item.code,item.GameProviderCode)">
                  <img class="d-block jackpot-button-img" [src]="'assets/jackpot/' + item.code + '/'+ item.code +'-cta-btn.png'" [alt]="item.name">
                  <span class="jackpot-button-text"  >{{ 'Play Now' | translate }}</span>
                </div>
                <div class="jacpot-number">{{ onGetCurrencyCode()+' ' }}<app-client-odometer [number]="transferAmount(jackpot[i]['amount'][onGetCurrencyCode()])" [config]="odometerConfig"></app-client-odometer></div>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </owl-carousel-o>
    </div>
    <div class="slider-overlay"></div>
  </div>
</ng-container>
<ng-template #elseTemplate>
  <div class="slider-inner"  *ngIf="jackpot?.length > 0 && PTisActive && ( onGetCurrencyCode() =='MYR' || onGetCurrencyCode() =='IDR') && checkPTgame()">
    <div class="swiper-container swiper-parent">
      <owl-carousel-o [options]="customOptionsJacpot">
        <ng-template carouselSlide *ngFor="let gameCode of gameCodeByJacpotPostionPt; let g = index">
          <ng-container *ngFor="let item of jackpot; let i = index">
            <div class="custom-contaier m-0 p-0" *ngIf="item.amount[onGetCurrencyCode()] && gameCode == item.code && gameCodeByJacpotPt[item.code]  && gameListPt[gameCodeByJacpotPt[item.code]] && item.GameProviderCode == 'PTI' ">
              <img class="d-block w-100"  [src]="'assets/jackpot/' + item.code + '/'+ item.code +'.gif'" [alt]="item.name">
              <div class="custom-contaier-jackpot">
                <img class="d-block jackpot-bg  w-100"  [src]="'assets/jackpot/' + item.code + '/'+ item.code +'_title.gif'" [alt]="item.name">
                <div class="d-block jackpot-button m-0 p-0" (click)="onLaunchGame(item.code,item.GameProviderCode)">
                  <img class="d-block jackpot-button-img" [src]="'assets/jackpot/' + item.code + '/'+ item.code +'-cta-btn.png'" [alt]="item.name">
                  <span class="jackpot-button-text"  >{{ 'Play Now' | translate }}</span>
                </div>
                <div class="jacpot-number">{{ onGetCurrencyCode()+' ' }}<app-client-odometer [number]="transferAmount(jackpot[i]['amount'][onGetCurrencyCode()])" [config]="odometerConfig"></app-client-odometer></div>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </owl-carousel-o>
    </div>
    <div class="slider-overlay" *ngIf="checkPTgame()"></div>
  </div>
</ng-template>


